import React, { useState } from 'react'
import { Panel } from 'rsuite'
import MiniProjectInfo from './MiniProjectInfo'
import ProjectBasedItemsTable from './ProjectBasedItemsTable'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { sessionSetItemObj, sessionGetItemStr } from '../../utils/sessionHelpers'
import { doneLoading, startLoading } from '../../utils/loading'
import { getProjectBaseInfo } from '../../redux/actions/projectBasedItems'

export default function ProjectBasedItemsWidget(props) {
  // const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const history = useHistory()

  const handleSelectRowData = (rowData) => {
    // console.log('handleSelectRowData ', rowData)

    rowData.periodOfLength = formSchema.period.length || 0

    //sessionSetItemObj('param', rowData)
    sessionSetItemObj('periodInfo', rowData)

    history.push({
      pathname: pathname.incomeAndExpense.VoucherList,
    })
  }

  const handleSelectPeriodicManagement = (rowData) => {
    // console.log('handleSelectPeriod', rowData)
    rowData.periodOfLength = formSchema.period.length || 0

    //sessionSetItemObj('param', rowData)
    sessionSetItemObj('periodInfo', rowData)

    history.push({
      pathname: pathname.incomeAndExpense.PeriodicManagement,
    })
  }

  const handleReload = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const projectCode = sessionGetItemStr('projectCode')
      const _schema = await getProjectBaseInfo(projectCode)
      if (_schema.model) {
        setFormSchema(_schema.model)
      }
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel shaded header={' '} bordered>
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        <ProjectBasedItemsTable
          schema={formSchema?.period || []}
          pagination={true}
          loading={isLoading}
          disabled={formSchema?.disabled}
          onSelect={handleSelectRowData}
          onSelectPeriodicManagement={handleSelectPeriodicManagement}
          onReload={handleReload}
        />
      </Panel>

      {isLoading && <OverlayLoader />}
    </>
  )
}
